<template>
  <div class="partyBuilding">
    <div class="bg-box">
      <div class="party-wrap">
        <div class="party-top">
          <div class="top-left">
            <img class="logo" src="../../../../static/img/footerlogo.png" alt="">
            <div class="main-title">
              <p>国家海洋标准计量中心</p>
              <p>National Center Of Ocean Standards And Metrology</p>
            </div>
          </div>
          <p class="party-right"><span>English </span>/ 中文</p>
        </div>
        <div class="party-search">
          <!-- <partySearch></partySearch> -->
          <p class="position">当前位置：  <span @click="toPage({name:'Index'})">首页</span> > 党建专题</p>
          <img class="positionImg" src="../../../../static/img/wenzi.png" alt="">
        </div>
        <div class="party-content">
          <div class="content-left">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in buildingSwiper" :key='item.id' @click="toPage({name:'breDetails',query:{id:item.id}})">
                  <img :src="item.cover">
                  <div class="section-text">{{item.title}}</div>
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="content-right">
            <ul>
              <li v-for='item in buildingList' :key='item.id' @click="toPage({name:'breDetails',query:{id:item.id}})">
                <p>{{item.title}}</p>
                <span>{{item.add_time | parseTime('{y}-{m}-{d}')}}</span>
              </li>
            </ul>
            <button  @click="toPage({name:'brecruitment'})">MORE +</button>
          </div>
        </div>
      </div>
    </div>
    <partyFoot></partyFoot>
  </div>
</template>

<script>
  import partySearch from "@/components/views/PartyBuilding/partySearch";
  import partyFoot from "@/components/views/PartyBuilding/partyFoot";
  import Vue from "vue";
  import "../../../../static/css/swiper-4.1.0.min.css";
  import Swiper from "../../../../static/js/swiper-4.1.0.min.js";
  import { userApi } from "@/api/user.js";
  export default {
    data() {
      return {
        swiper: null,
        buildingList:[],
        buildingSwiper:[]
      }
    },
    components: {
      partySearch,
      partyFoot
    },
    mounted() {
      this.getBuildingList();
      this.getBuildingSwiper();
    },
    methods: {
      getBuildingList() {
        const params = {
          page: 1,
          count: 4
        };
        userApi.getBuildingList(params).then(res => {
          this.buildingList = res.data.list;
        });
      },
      getBuildingSwiper(){
        let that = this;
        userApi.getBuildingSwiper().then(res => {
          that.buildingSwiper = res.data.list;
          setTimeout(() => {
            that.swiperDom();
          }, 1000);
        });
      },
      swiperDom(){
        this.swiper = new Swiper('.swiper-container', {
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          loop: false,
          paginationClickable: true,
          slideToClickedSlide: true,
          preventLinksPropagation: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          }
        })
      },
      toPage(url) {
        if(url.name === "BusinessIntro"&&url.query.type === 1){
          //跳转指定外链
          if(url.query.firstId==='41'){
            window.open('http://www.ncosm.org.cn/ncosm/portal/index#page4')
          }else if(url.query.firstId==='4'){
            window.open('http://www.ncosm.org.cn/ncosm/portal/index')
          }else{
            this.$router.push(url);
          }
        }else{
          this.$router.push(url);
        }
      },
    },
  }
</script>

<style scoped="scoped">
  .bg-box {
    width: 100%;
    height: 980px;
    background: url(../../../../static/img/party-bg.png) no-repeat center;
    background-size: 100% 100%;
  }

  .party-wrap {
    width: 1240px;
    margin: 0 auto;
  }

  .party-top {
    display: flex;
    justify-content: space-between;
    padding-top: 76px;
  }

  .top-left {
    display: flex;
    justify-content: flex-start;
  }

  .logo {
    width: 104px;
    height: 104px;
    margin-right: 36px;
  }

  .main-title p {
    color: #EEDDBA;
    font-size: 56px;
    padding-top: 8px;
  }

  .main-title p:last-child {
    font-size: 20px;
    padding-top: 12px;
  }

  .party-right {
    color: #FFFFFF;
    font-size: 18px;
    padding-top: 74px;
  }

  .party-right span {
    color: #F58C9E;
  }

  .party-search {
    display: flex;
    justify-content: flex-start;
    padding-top: 50px;
    padding-bottom: 142px;
    position: relative;
  }
  .party-search .positionImg{
    width: 550px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin:100px auto 0;
  }

  .position {
    color: #FFFFFF;
    font-size: 16px;
    line-height: 40px;
    margin-left: 20px;
    span{
      cursor: pointer;
    }
  }

  .party-content {
    display: flex;
    justify-content: center;
  }

  .content-left {
    width: 784px;
    height: 480px;
  }

  .swiper-container {
    width: 100%;
    height: 480px;
    overflow: hidden;
  }

  .swiper-slide {
    cursor: pointer;
    text-align: center;
    font-size: 18px;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    position: relative;
  }

  .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .section-text{
    width:100%;
    height: 80px;
    background: rgba(0,0,0,0.8);
    color: #FFFFFF;
    position: absolute;
    left:0;
    bottom: 0;
    font-size: 20px;
    line-height: 80px;
    box-sizing: border-box;
    padding:0 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .content-right{
    width:442px;
    height: 480px;
    background: #EEDDBA;
  }
  .content-right li{
    box-sizing: border-box;
    width:100%;
    padding:0 33px 20px 33px;
    border-bottom: 1px solid #FFFFFF;
    cursor: pointer;
  }
  .content-right li p{
    font-size:18px ;
    color: #9D6928;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding:36px 0 16px 0;
  }
  .content-right li span{
    font-size: 16px;
    color: #9D6928;
  }
  .content-right button{
    height: 50px;
    background: #EEDDBA;
    width: 100%;
    border: none;
    color: #9D6928;
    font-size: 16px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/PartyBuilding/partyBuilding.vue